import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authApi } from "../auth/authApi";
import logo from "../assets/img/boersenkusecpixabay.png";
import "./login.css";
import TurnstileWidget from "../components/TurnstileWidget";

const LANGUAGES = [
    { code: "en", label: "English", flag: "🇬🇧" },
    { code: "de", label: "Deutsch", flag: "🇩🇪" },
    { code: "fr", label: "Français", flag: "🇫🇷" },
    { code: "es", label: "Español", flag: "🇪🇸" },
    { code: "uk", label: "Українська", flag: "🇺🇦" },
    { code: "tr", label: "Türkçe", flag: "🇹🇷" }
];

export default function RegisterPage() {
    const [form, setForm] = useState({
        userName: "",
        email: "",
        password: "",
        passwordRepeat: "",
        preferredLanguage: "en"
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [done, setDone] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState("");
    const [message, setMessage] = useState("");

    const onChange = (e) => {
        const { name, value } = e.target;

        setForm((current) => ({
            ...current,
            [name]: value
        }));
    };
    const selectLanguage = (preferredLanguage) => {
        setForm((current) => ({
            ...current,
            preferredLanguage
        }));
    };

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setMessage("");

        if (!turnstileToken) {
            setMessage("Bitte bestätige zuerst, dass du ein Mensch bist.");
            return;
        }

        if (!form.userName || !form.email || !form.password || !form.passwordRepeat) {
            setError("Bitte alle Felder ausfüllen.");
            return;
        }

        if (form.password !== form.passwordRepeat) {
            setError("Die Passwörter stimmen nicht überein.");
            return;
        }

        try {
            setLoading(true);

            await authApi.register({
                userName: form.userName,
                email: form.email,
                password: form.password,
                preferredLanguage: form.preferredLanguage
            });

            setDone(true);
        } catch (err) {
            setError(err.message || "Registrierung fehlgeschlagen.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-root">
            <div className="login-left">
                <img src={logo} alt="Logo" className="login-logo" />
                <span className="company-name">
                    Künstliche-Intelligenz-Marktanalyse-Terminal
                </span>
            </div>

            <div className="login-divider" />

            <div className="login-right">
                <h1>Erstanmeldung</h1>
                <p>Bitte Zugangsdaten anlegen und E-Mail-Adresse bestätigen.</p>

                {done ? (
                    <div className="login-success">
                        Falls die E-Mail-Adresse gültig ist, wurde ein Bestätigungslink versendet.
                    </div>
                ) : (
                    <form onSubmit={submit}>
                        <input
                            style={{ width: "300px" }}
                            name="userName"
                            placeholder="USERNAME"
                            value={form.userName}
                            onChange={onChange}
                        />

                        <input
                            style={{ width: "300px" }}
                            name="email"
                            type="email"
                            placeholder="E-MAIL"
                            value={form.email}
                            onChange={onChange}
                        />

                        <input
                            style={{ width: "300px" }}
                            name="password"
                            type="password"
                            placeholder="PASSWORT"
                            value={form.password}
                            onChange={onChange}
                        />

                        <input
                            style={{ width: "300px" }}
                            name="passwordRepeat"
                            type="password"
                            placeholder="PASSWORT WIEDERHOLEN"
                            value={form.passwordRepeat}
                            onChange={onChange}
                        />

                        <div style={{ width: 300, margin: "12px 0" }}>
                            <div style={{ marginBottom: 8, fontSize: 14 }}>
                                Bevorzugte Sprache
                            </div>

                            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                {LANGUAGES.map((language) => {
                                    const selected =
                                        form.preferredLanguage === language.code;

                                    return (
                                        <button
                                            key={language.code}
                                            type="button"
                                            title={language.label}
                                            aria-label={language.label}
                                            aria-pressed={selected}
                                            onClick={() => selectLanguage(language.code)}
                                            style={{
                                                width: 40,
                                                minWidth: 40,
                                                height: 40,
                                                padding: 0,
                                                borderRadius: 8,
                                                border: selected
                                                    ? "2px solid #1976d2"
                                                    : "1px solid rgba(255,255,255,0.25)",
                                                background: selected
                                                    ? "rgba(25,118,210,0.18)"
                                                    : "rgba(255,255,255,0.08)",
                                                color: selected
                                                    ? "#ffffff"
                                                    : "#d5d5d5",
                                                fontSize: 22,
                                                cursor: "pointer",
                                                transition: "all .2s ease",
                                                transform: selected
                                                    ? "scale(1.08)"
                                                    : "scale(1)",
                                                boxShadow: selected
                                                    ? "0 0 12px rgba(25,118,210,.45)"
                                                    : "none",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        >
                                            {language.flag}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>

                        <TurnstileWidget
                            style={{ width: "300px" }}
                            onVerify={setTurnstileToken}
                        />

                        {message && <div className="login-error">{message}</div>}
                        {error && <div className="login-error">{error}</div>}

                        <button style={{ width: "300px" }} disabled={loading}>
                            {loading ? "Wird angelegt ..." : "Erstanmeldung"}
                        </button>

                        <div className="login-links">
                            <Link to="/login" className="login-link">
                                Zurück zur Anmeldung
                            </Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
